import React, {useState} from 'react';
import { Table } from 'react-bootstrap';
import {Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAlignLeft } from "@fortawesome/free-solid-svg-icons"; 
import {Button} from "react-bootstrap";
import Rightbar from './Rightbar';

  
export default function ExhibitorPortalhome(){ 
const [sidebar, setsidebar] = useState(false);
const [mainbar, setmainbar] = useState(false);
const toggle = () => {
    setsidebar(!sidebar);
    setmainbar(!mainbar);
}
return(
  <>
<section className="sec-container" >
   <div className='container'>
      <div className='portalevent'>
         <div className='row'>
            <div className={`col-md-3 portal-sidebar leftbar-close ${sidebar ? 'close' : ''}`}>
                  <div >
                  <Rightbar/>
                  </div>
               </div>
               <div className={`col-md-9 rightbar-open ${mainbar ? 'open' : ''}`}>
                  <div className='rightbar '>
                  <Button variant="outline-info" onClick={toggle}>
                    <FontAwesomeIcon icon={faAlignLeft} />
                  </Button>
                  <h1>Welcome to your Andrey Orlov Exhibitor Portal!</h1>
                            <p>
                                Please use the buttons on the left to view and submit all relevant show information. In order to be best 
                                prepared for the fair, please read each section thoroughly and complete ALL forms by the required 
                                deadlines listed below. We recommend logging into your portal daily to be sure you are keeping up 
                                with all requirements in a timely manner. Please note, it is important to complete each of the first three 
                                <i> steps in order, before you will be able to access the remaining pages.</i>
                            </p>
                            <p>If you have question please Contact us at <Link to="">er@photola.com</Link></p>
                            <Table striped>
                                <thead>
                                    <tr>
                                        <th>DEADLINES</th>
                                        <th>DUE DATE</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>Read & Accept Show Schedule</td>
                                        <td>8/16</td>
                                    </tr>
                                    <tr>
                                        <td>Read & Accept Rules & Regulations</td>
                                        <td>8/16</td>
                                    </tr>
                                    <tr>
                                        <td>Submit Insurance (COI Certificate) </td>
                                        <td>8/23</td>
                                    </tr>   
                                    <tr>
                                        <td>Select Shipping & Schedule Load-In </td>
                                        <td>8/23</td>
                                    </tr>
                                    <tr>
                                        <td>Submit Catalogue Listing </td>
                                        <td>8/16</td>
                                    </tr>
                                    <tr>
                                        <td>Submit Catalogue Image </td>
                                        <td>8/16</td>
                                    </tr>
                                    <tr>
                                        <td>Submit Booth Design </td>
                                        <td>8/16</td>
                                    </tr>
                                    <tr>
                                        <td>Submit Programming for Inclusion in Fair Calendar</td>
                                        <td>8/23</td>
                                    </tr>
                                    <tr>
                                        <td>Submit Exhibitor Badges</td>
                                        <td>9/10</td>
                                    </tr>
                                    <tr>
                                        <td>Submit Guest List</td>
                                        <td>9/10</td>
                                    </tr>
                                    <tr>
                                        <td>Final Payment</td>
                                        <td>8/23</td>
                                    </tr>
                                    <tr>
                                        <td>Submit Social Media Content</td>
                                        <td>9/10</td>
                                    </tr>
                                    <tr>
                                        <td>Create Virtual Booth *</td>
                                        <td>9/10</td>
                                    </tr>
                                    <tr>
                                        <td>Submit Guest List</td>
                                        <td>9/10</td>
                                    </tr>
                                </tbody>
                            </Table>
                            <br/>
                            <i className='red'>
                                *In the event an exhibitor sells an artwork in their virtual booth after the deadline (including during the fair), 
                                they may add another artwork to replace it. Any proposed changes must be submitted to er@photola.com for approval.

                            </i>
                  </div>
            </div>
         </div>
      </div>
   </div>
</section>  

 
</>
)
}
